<template>
  <b-container :fluid="true">
    <b-tabs content-class="mt-3">
      <b-tab title="Not approved" active @click="fetchApprovalTab">
        <approval-top-line />
        <approval-tab/>
      </b-tab>
      <b-tab title="Sent" @click="fetchApprovedTab">
        <approved-tab />
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import ApprovalTab from '@/components/common/invoices-approval/ApprovalTab'
import ApprovedTab from '@/components/common/invoices-approval/ApprovedTab'
import ApprovalTopLine from '@/components/common/invoices-approval/ApprovalTopLine'

export default {
  name: 'SalesInvoicesApproval',
  components: { ApprovalTopLine, ApprovalTab, ApprovedTab },
  computed: mapState('invoicesApproval', ['searchPayload']),
  async created () {
    await this.$store.dispatch('invoicesApproval/loadApprovalTab')
  },
  methods: {
    async fetchApprovalTab () {
      await this.$store.dispatch('invoicesApproval/setSelected', [])
      await this.$store.dispatch('invoicesApproval/loadApprovalTab', { params: this.searchPayload })
    },
    async fetchApprovedTab () {
      await this.$store.dispatch('invoicesApproval/setSelected', [])
      await this.$store.dispatch('invoicesApproval/loadApprovedTab', { params: this.searchPayload })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/modules/sales/invoices-approval/SalesInvoicesApproval.vue